import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appTags',
  getURL: 'appId/appTagsPlay',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  sessionParams:['appId'],
  emptyMessage: "You don’t have any tags yet. Go to the Tag Manager to create your first one.",
  emptyButtonUrl:"/tagmanager/new",
  emptyButton:"+ Create New Tag",
  createButton: "Create New Tag",
  createButtonUrl: "/tagmanager/new",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the tag.',
    },
  ],
};
